import Action from "../actions"

export function masterDataViewReducer(state = {
    roles: [],
    occupations: [],
    districts: [],
    provinces: []
}, action) {
    if (action.type === Action.SET_MASTER_DATA_VIEW) {
        return action.data
    }
    return state;
}
